import React from 'react'

export default ({extraClassName, children}) => (
  <div className={`card-container ${extraClassName}`}>{children}</div>
)



// WEBPACK FOOTER //
// ./client/src/components/Card.js